import GenericVModel from '@components/mixins/genericVModel'
import Quill from 'quill'

export default {
  name: 'EditBlockTextInput',
  mixins: [GenericVModel],
  props: {
    /**
     * the type of the input (text/textarea & other default types)
     */
    type: {
      required: false,
      type: String,
      default: 'text',
    },
    /**
     * the max length for the input/textarea
     */
    maxlength: {
      required: false,
      type: Number,
      default: 200,
    },
    /**
     * if the input is meant to be a url
     */
    url: {
      required: false,
      type: Boolean,
      default: false,
    },
    /**
     * the placeholder text
     */
    placeholder: {
      required: false,
      type: String,
      default: '',
    },
    /**
     * the placeholder text
     */
    suffix: {
      required: false,
      type: String,
      default: '',
    },
    /**
     * Icon at end of element
     */
    infoIcon: {
      required: false,
      type: Boolean,
      default: false,
    },
    /**
     * text to be displayed when hovering over the info icon
     */
    infoContent: {
      required: false,
      type: String,
      default: '',
    },
    /**
     * text to be displayed under input when selected
     */
    dangerContent: {
      required: false,
      type: String,
      default: '',
    },
    /**
     * text to be displayed under input when selected
     */
    isRichText: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      focus: false,
      quill: null,
    }
  },
  mounted() {
    if (this.isRichText) {
      this.initQuill()
    }
  },
  methods: {
    initQuill() {
      this.quill = new Quill(this.$refs.wisiwyg, {
        modules: {
          toolbar: [
            // [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            // [{ 'align': [] }],
          ],
        },
        theme: 'snow',
      })

      this.quill.clipboard.dangerouslyPasteHTML(this.input)

      this.quill.on('text-change', (delta, oldDelta, source) => {
        if (source === 'user') {
          this.input = this.quill.getSemanticHTML()
        }
      })
    },
  },
  beforeDestroy() {
    if (this.isRichText && this.quill) {
      this.quill.off('text-change')
      this.quill = null
    }
  },
}
